// Client-measured timings for the latency dashboard (PRD: chat feel). Batched, sent every 20 s and on page hide.
import type { LatencyKind, LatencySample } from "@bloom/shared";

let queue: LatencySample[] = [];
let serverId: string | undefined;

export function record(kind: LatencyKind, ms: number) {
  if (!Number.isFinite(ms) || ms < 0) return;
  queue.push({ kind, ms: Math.round(ms * 10) / 10 });
  if (queue.length >= 100) flush();
}

export function setMetricsServer(id: string) {
  serverId = id;
}

export function flush(beacon = false) {
  if (!queue.length) return;
  const body = JSON.stringify({ samples: queue.splice(0, 200), serverId });
  if (beacon && navigator.sendBeacon) navigator.sendBeacon("/api/metrics", body);
  else void fetch("/api/metrics", { method: "POST", body, headers: { "content-type": "application/json" }, keepalive: true }).catch(() => {});
}

setInterval(() => flush(), 20_000);
addEventListener("pagehide", () => flush(true));
document.addEventListener("visibilitychange", () => document.visibilityState === "hidden" && flush(true));

/** Time from navigation start to the first channel full of messages on screen. Recorded once per page load. */
let coldStartDone = false;
export function markColdStart() {
  if (coldStartDone) return;
  coldStartDone = true;
  requestAnimationFrame(() => record("cold_start", performance.now()));
}
